export const enum NotificationPosition {
  TOP = 'top',
  MODAL = 'modal',
  TAB = 'tab',
}
